<template>
    <v-container fluid class="pt-0">
        <v-row>
            <v-col cols="12" class="pa-0">
                <v-sheet class="" color="#008dd4" height="10vh"></v-sheet>
            </v-col>
            <v-col cols="12" style="position:relative; top: -60px">
                <v-alert border="top" color="red lighten-2" dark>
                No guardamos información de las tarjetas de débito o crédito, ya que procesamos el pago por medio de la plataforma Mercado Pago de Mercado Libre o PayPal, puedes seleccionar los cursos que deseas pagar al dar clic en el comprobante de pago pendiente.
                </v-alert>
            </v-col>
            <v-col cols="12" lg="4" md="5" style="position:relative; top: -60px">
                <v-card>
                    <v-list two-line subheader>
                        <v-list-item>
                            <v-list-item-avatar>
                                <v-icon color="#008dd4" x-large>mdi-currency-usd</v-icon>
                            </v-list-item-avatar>

                            <v-list-item-content>
                                <v-list-item-title><strong>Mi balance</strong></v-list-item-title>
                                <v-list-item-subtitle class="text-h3">${{ user.country_code == 'MX' ? balance.balance : balance.dollar_balance }}</v-list-item-subtitle>
                            </v-list-item-content>

                        </v-list-item>
                    </v-list>
                </v-card>

                <v-card class="mt-4">
                    <v-list two-line subheader>
                        <v-list-item>
                            <v-list-item-avatar>
                                <v-icon color="#008dd4" x-large>mdi-receipt</v-icon>
                            </v-list-item-avatar>

                            <v-list-item-content>
                                <v-list-item-title><strong>Total de pagos pendientes</strong></v-list-item-title>
                                <v-list-item-subtitle class="text-h3">${{ pendingTotal }}</v-list-item-subtitle>
                            </v-list-item-content>

                        </v-list-item>
                    </v-list>
                </v-card>

                <v-card v-if="user.country_code == 'MX'" class="mt-4">
                    <v-list class="pb-0" two-line subheader>
                        <v-list-item>
                            <v-list-item-avatar>
                                <v-icon color="#008dd4" x-large>mdi-credit-card</v-icon>
                            </v-list-item-avatar>
  
                            <v-list-item-content>
                                <v-list-item-title><strong>Datos bancarios</strong></v-list-item-title>
                                <v-list-item-subtitle>Información para realizar pagos.</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                    <v-card-actions>
                        <v-btn text :color="color" @click="info_dialog = !info_dialog" block>MOSTRAR</v-btn>
                    </v-card-actions>
                </v-card>

                <v-card class="mt-4">
                    <v-btn class="mercado-pago-button"  @click="pay()" block> <v-img class="logo-mercado-pago" src="https://logotipoz.com/wp-content/uploads/2021/10/version-horizontal-large-logo-mercado-pago.webp" contain></v-img> </v-btn>
                </v-card>
                <v-card class="mt-4">
                    <div id="paypal-button-container"></div>
                </v-card>

                <v-card v-if="user.country_code == 'MX'" class="mt-4">
                    <v-btn color="success" @click="proofs_dialog = !proofs_dialog" block><strong>SUBIR COMPROBANTES DE PAGO</strong></v-btn>
                </v-card>
            </v-col>

            <v-col lg="8" md="7" style="position:relative; top: -60px">
                
               <v-card>
                   <v-card-text v-if="Object.keys(payments).length > 0">
                       <template v-for="(payment, index) in payments">
                            <v-card v-if="payment.quantity < 0" outlined shaped :key="index"  @click="select_course(payment)" class="mb-2">

                                <v-card-title>
                                    <v-chip class="mr-2" small :color="payment.verified == 1 ? 'success' : 'error'">{{ payment.verified == 1 ? 'Pago correcto' : 'Pendiente' }}</v-chip>
                                    {{ payment.date }}
                                    <v-spacer></v-spacer>
                                    <v-chip v-if="payment.verified == 0" class="pa-2" small :color="payment.select == true ? 'success' : 'default'">{{ payment.select == true ? 'Curso seleccionado para pagar' : 'Disponible para pago' }}</v-chip>
                                    <!-- <v-tooltip left v-if="payment.verified == 1">
                                        <template v-slot:activator="{ on, attrs }">
                                                <v-btn v-bind="attrs" icon v-on="on" color="primary" style="text-transform: lowercase">
                                                    <v-icon>mdi-printer</v-icon>
                                                </v-btn>
                                        </template>
                                        <span>Descargar recibo</span>
                                    </v-tooltip> -->
                                </v-card-title>
                                <v-card-subtitle v-if="payment.verified == 1">ID de transacción {{ payment.proof ? payment.proof.folio+'-'+payment.id : payment.id }}</v-card-subtitle>
                                <v-card-text>
                                    <v-simple-table>
                                        <template v-slot:default>
                                            <thead>
                                                <tr>
                                                    <th>Descripción</th>
                                                    <th class="text-right">Total</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>{{ payment.description }}</td>
                                                    <td class="text-right">{{user.country_code == "MX"?"MXN":"USD"}}{{ user.country_code == "MX"?Math.abs(payment.quantity):Math.abs(payment.dollar_quantity) }}{{ payment.quantity %1 === 0 ? '.00' : '' }}</td>
                                                </tr>
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                    <v-divider></v-divider>
                                    <v-simple-table flat>
                                        <template v-slot:default>
                                            <tbody>
                                                <tr>
                                                    <td class="text-right"><strong>Impuestos</strong></td>
                                                    <td class="text-right">{{user.country_code == "MX"?"MXN":"USD"}}0.00</td>
                                                </tr>
                                                <tr>
                                                    <td class="text-right"><strong>Importe cobrado</strong></td>
                                                    <td class="text-right" v-if="payment.verified == 1">{{user.country_code == "MX"?"MXN":"USD"}}{{ user.country_code == "MX"?Math.abs(payment.quantity):Math.abs(payment.dollar_quantity) }}{{ payment.quantity % 1 === 0 ? '.00' : '' }}</td>
                                                    <td class="text-right" v-else>{{user.country_code == "MX"?"MXN":"USD"}}0.00</td>
                                                </tr>
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                </v-card-text>
                            </v-card>
                       </template>
                    </v-card-text>
                    <template v-else>
                        <v-card-text>
                            <p class="text-center mb-0">Sin pagos registrados</p>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn block color="#008dd4" dark href="/my-courses/select-course">Seleccionar curso</v-btn>
                        </v-card-actions>
                    </template>
               </v-card>
            </v-col>
        </v-row>

        <v-dialog v-model="info_dialog" width="600">
            <v-card>
                <v-card-title>Datos bancarios</v-card-title>
                <v-card-text class="pa-5">
                    <h3 class=" mb-5">Información necesaría para realizar pagos a la institución. Una vez realizado el pago, deberá subir una fotografía de su comprobante. Cuando el pago sea verificado, se realizarán los pagos pendientes y el restante será sumado a su balance.</h3>
                    <v-simple-table flat>
                        <template v-slot:default>
                            <!-- Datos hardcodeados, tabla de cuentas -->
                            <tbody>
                                <tr>
                                    <td>CLABE</td>
                                    <td><strong>012 180 00469235582 8</strong></td>
                                </tr>
                                <tr>
                                    <td>Número de tarjeta</td>
                                    <td><strong>4152 3138 7681 3309</strong></td>
                                </tr>
                                <tr>
                                    <td>Banco</td>
                                    <td><strong>BBVA Bancomer</strong></td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </v-card-text>
                <v-card-actions>
                    <v-btn class="mx-auto" block @click="info_dialog = false" text><strong>Aceptar</strong></v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>


        <proofs :dialog="proofs_dialog" :proofs="proofs" :store_url="store_proof_url"></proofs>
        <mercadopago :dialog="payment_dialog" :payments="payments" ></mercadopago>
    </v-container>
</template>
<script>

import proofs from './proofs'

export default {
    props:['user','_balance','_payments','_proofs'],
    components:{
        proofs
    },
    data: () => ({
        data_url:'/payments',
        store_proof_url:'/payments/proof/store',
        color:'#000',
        info_dialog:false,
        proofs_dialog:false,
        transfer_dialog:false,
        payment_dialog:false,
        balance:"",
        payments:"",
        proofs:"",
        
    }),

    created(){
        this.balance  = Object.assign({}, this._balance)
        this.payments =  this._payments
        this.payments.forEach((payment, index) => {
            this.$set(this.payments[index], 'select', true);
        });
        this.proofs   = Object.assign({}, this._proofs)
        console.log(this.payments)
    },

    methods:{
        pay() {
            let payments_ids = this.payments.filter(payment => {
                if(payment.verified == false && payment.select == true)
                    return payment.id
            }).map(payment => payment.id)
            let data = {
                folio: this.user.folio,
                ids: payments_ids
            }
            console.log('los datos son')
            console.log(data)
            axios.post('/payments/pay_with', { data }).then(response => {
                window.location.href = response.data.init_point;
                //console.log(response.data.preference)
                // if(response.data.init_point)
                //window.open(response.data.init_point, '_blank');
            }).catch(error => {
                    console.log(error);
            });
        },
        select_course:function(payment){
            console.log('se dio click en uno de los pagos')
            if(payment.verified)
                payment.select = !payment.select
            console.log(payment)
        },
        getData:function(){
            axios.get(this.data_url).then(response => {
                this.balance  = response.data.balance
                this.payments = response.data.payments
                this.proofs   = response.data.proofs
            }).catch(error => {})
        },
        paypalPayment:function(){
            let payments_ids = this.payments.filter(payment => {
                if(payment.verified == false && payment.select == true)
                    return payment.id
            }).map(payment => payment.id)
            let data = {
                folio: this.user.folio,
                ids: payments_ids
            }
            console.log('los datos de pago son los siguiente')
            console.log(data)
            axios.post('/payments/pay_with_paypal', { data }).then(response => {
                //console.log(response)
                window.location.href = response.data.redirect_url;
            }).catch(error => {
                console.log(error);
            });
        }
    },
    mounted() {
        var t = this
        paypal.Buttons({
            createOrder() {
                t.paypalPayment()
            },
            onApprove(data) {
                return fetch("/my-server/capture-paypal-order", {
                    method: "POST",
                    headers: {
                    "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                    orderID: data.orderID
                    })
                })
                .then((response) => response.json())
                .then((orderData) => {
                    // Successful capture! For dev/demo purposes:
                    console.log('Capture result', orderData, JSON.stringify(orderData, null, 2));
                    const transaction = orderData.purchase_units[0].payments.captures[0];
                    alert(`Transaction ${transaction.status}: ${transaction.id}\n\nSee console for all available details`);
                    // When ready to go live, remove the alert and show a success message within this page. For example:
                    // const element = document.getElementById('paypal-button-container');
                    // element.innerHTML = '<h3>Thank you for your payment!</h3>';
                    // Or go to another URL:  window.location.href = 'thank_you.html';
                });
            }
        }).render('#paypal-button-container');
    },

    computed:{
        pendingTotal: function(){
            let total = 0
            this._payments.forEach(payment => {
                if(payment.quantity < 0 && payment.verified == 0)                     
                    total += (this.user.country_code == 'MX'? Math.abs(payment.quantity):Math.abs(payment.dollar_quantity))
            });

            return total
        }
    }
}
</script>
<style>
.mercado-pago-button {
  display: flex;
  align-items: center;
  font-weight: bold;
  background-color: #FFDD00;
  color: #333333;
  border-color: #FFDD00;
}

.mercado-pago-button .logo-mercado-pago {
  width: 24px;
  height: 24px;
  margin-right: 8px;
}
</style>